const CEF_SHARP_OBJECT_NOT_FOUND = /Object Not Found Matching Id:\d+, MethodName:[\w$]+, ParamCount:\d+/;

function matchesCefSharpObjectNotFound(value) {
    if (typeof value === 'string') {
        return CEF_SHARP_OBJECT_NOT_FOUND.test(value);
    }

    if (value && typeof value === 'object') {
        if (matchesCefSharpObjectNotFound(value.message) || matchesCefSharpObjectNotFound(value.errorMessage)) {
            return true;
        }

        try {
            return CEF_SHARP_OBJECT_NOT_FOUND.test(JSON.stringify(value));
        } catch (error) {
            return false;
        }
    }

    return false;
}

export function shouldSendBugsnagEvent(event) {
    if (matchesCefSharpObjectNotFound(event.originalError)) {
        return false;
    }

    if (Array.isArray(event.errors) && event.errors.some(function (error) {
        return matchesCefSharpObjectNotFound(error.errorClass) || matchesCefSharpObjectNotFound(error.errorMessage);
    })) {
        return false;
    }

    if (typeof event.getMetadata === 'function') {
        if (
            matchesCefSharpObjectNotFound(event.getMetadata('unhandledrejection handler')) ||
            matchesCefSharpObjectNotFound(event.getMetadata('unhandledRejection handler'))
        ) {
            return false;
        }
    }

    return true;
}
